'use client';

import { BidDocument } from 'models/bid';
import { ProductDocument, Variation } from 'models/product';
import BaseModal from '../../../components/modals/BaseModal';
import { PlaceABidForm } from 'features/auctions/forms/PlaceABidForm';

type PlaceABidModalProps = {
  product: ProductDocument;
  isOpen: boolean;
  dismiss: () => void;
};

export default function PlaceABidModal({
  product,
  isOpen,
  dismiss,
}: PlaceABidModalProps) {
  return (
    <>
      <BaseModal
        isOpen={isOpen}
        dismiss={() => {
          dismiss();
        }}
        className="w-[55rem]"
        title="Place Your Bid"
      >
        <PlaceABidForm product={product} onSubmitSuccess={() => dismiss()} />
      </BaseModal>
    </>
  );
}
